<div class="blackdim"></div>
<div class="fullpage narrative" (click)="clickOk()">
    <div class="modal">
        <div *ngIf="storyA" app-read-story [story]="storyA"></div>
        <div *ngIf="storyB" app-read-story [story]="storyB"></div>
    </div>
    <div style="text-align: right;" class="button">&nbsp;</div>
</div>